import { FiShoppingBag } from "react-icons/fi";
import { formatPersianPrice } from "../../../services/customerMenuModel";

import { formatPersianNumber as persianNumber } from "../../../utils/persianNumber";

const CartSummaryBar = ({ itemCount, total, onOpen }) => {
  if (!itemCount) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-gray-100 bg-white/95 p-3 backdrop-blur" dir="rtl">
      <button type="button" onClick={onOpen} className="mx-auto flex min-h-12 w-full max-w-xl items-center justify-between rounded-xl bg-secondary px-4 font-bold text-white shadow-sm transition-colors hover:bg-secondary/90 focus:outline-none focus:ring-4 focus:ring-secondary/20">
        <span className="flex items-center gap-2"><FiShoppingBag /> مشاهده سبد <span className="rounded-full bg-white/20 px-2 py-0.5 text-xs">{persianNumber(itemCount)} آیتم</span></span>
        <span>{formatPersianPrice(total)}</span>
      </button>
    </div>
  );
};

export default CartSummaryBar;
